var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDispenserPump(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.999 15.25h2V8h4.5a1.5 1.5 0 100-3H8.059a5.04 5.04 0 00-5.014 4.538.42.42 0 00.418.462h.926a.987.987 0 00.883-.545A2.631 2.631 0 017.625 8H13v7.25zm6.5-6h-3.25v6c0 .042-.002.084-.006.125h1.059c1.273 0 2.453.668 3.108 1.76l2.126 3.543a.625.625 0 01-1.072.644l-2.126-3.544a2.375 2.375 0 00-2.037-1.153H10.7c-.835 0-1.608.438-2.037 1.153l-2.126 3.544a.625.625 0 01-1.072-.644l2.126-3.543a3.625 3.625 0 013.109-1.76h1.056a1.259 1.259 0 01-.006-.125v-6H7.625c-.523 0-1.001.296-1.235.764a2.237 2.237 0 01-2 1.236h-.927a1.67 1.67 0 01-1.662-1.836A6.29 6.29 0 018.06 3.75h11.439a2.75 2.75 0 110 5.5z",
    fill: "currentColor"
  })));
}
export default SvgDispenserPump;